module.exports = __webpack_public_path__ + "img/article_6_4.fa5fc790.png";